/**
 * InstructorDashboard object represents Dashboard API endpoints and their methods.
 */
const InstructorDashboard = {
  /**
   * Endpoint for retrieving dashboard information.
   * @memberof InstructorDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving dashboard information.
   * @property {string} method - The HTTP method for retrieving dashboard information (GET).
   */
  getInstructorDashboard: {
    url: "/instructor/dashboard",
    method: "GET",
  },
  /**
   * Endpoint for retrieving pie chart information.
   * @memberof InstructorDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving pie chart information.
   * @property {string} method - The HTTP method for retrieving pie chart information (GET).
   */
  getInstructorPieChartData: {
    url: "/instructor/dashboard/pie-chart",
    method: "GET",
  },

  /**
   * Endpoint for retrieving line graph information.
   * @memberof InstructorDashboard
   * @type {object}
   * @property {string} url - The URL for retrieving line graph information.
   * @property {string} method - The HTTP method for retrieving line graph information (GET).
   */
  getInstructorLineGraphData: {
    url: "/instructor/dashboard/line/graph",
    method: "GET",
  },

};

export default InstructorDashboard;
